import { Result, Typography } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'app/store';
import ToHomeButton from 'components/ToHomeButton';

/**
 * 
 * component to display when user clicks 'My Profile' or 'Settings' but
 * show_to_public is set to false
 */
export default function ErrorNotPublic() {
  const { user } = useSelector((state: RootState) => state.authentication);

  const userFullName = user?.preferred_first_name && user?.preferred_last_name ? `${user.preferred_first_name} ${user.preferred_last_name}` : 'user';
  
  return (
    <Result
      style={{ width: '600px', margin: '0 auto' }}
      icon={<div style={{ fontSize: '96px' }}>&#128678;</div>}
      subTitle={<p style={{ textAlign: 'left' }}>
        Dear {userFullName}, before profiling you in our system, there are a few pieces of information that we need to verify with you.
        <br />
        <br />
        Please send an email to <Typography.Link href='mailto:rio@sfu.ca'>rio@sfu.ca</Typography.Link>, so that we can connect with you. Thank you.
      </p>}
      extra={<ToHomeButton />}
    />
  );
}
